import React from 'react';
import { Container } from './ui/Container';
import { CTAButton } from './ui/CTAButton';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 border-b border-mp-border/70 bg-mp-black/80 backdrop-blur-md" data-id="element-146" data-mp="2dn5wwvih53n2">
      <Container className="flex h-16 items-center justify-between md:h-20" data-id="element-147" data-mp="2ik63d7j8k8ep">
        <a href="#top" className="flex items-center gap-2" data-id="element-148" data-mp="2nlbu4ztc5lll">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-mp-white text-[11px] font-heading font-bold text-mp-black md:h-9 md:w-9" data-id="element-149" data-mp="2rmfcpu2rpvqi">
            MP
          </span>
          <span className="font-heading text-sm uppercase tracking-wide text-mp-white md:text-base" data-id="element-150" data-mp="31bywr327vvmy">
            Maestro en Pista
          </span>
        </a>
        <CTAButton href="#oferta" variant="primary" size="md" fullWidthMobile={false} data-id="element-151" data-mp="36aij34kq39fu">
          Ver oferta
        </CTAButton>
      </Container>
    </header>;
}